import React, { memo, useEffect, useRef } from 'react'

import api from '../../../../services/api'
import useStyles from './style'

import {
  getMyContent as getApiMyContent,
  myContentError,
  setMyContent,
  updatedMyContent,
} from '../../../../redux/myContent/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Icon from '../../../atoms/display/icon'

import { ForumRounded as MyContentIcon } from '@material-ui/icons'
import Textfield from '../../../atoms/inputs/textfield'

function MyContentComponent() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const myContent = useSelector((state) => state.myContent)

  const myContentBoxRef = useRef()

  const getMyContent = async () => {
    dispatch(getApiMyContent())
    try {
      const response = await api.get(`/notepad`)
      if (response.status === 200) {
        dispatch(setMyContent(response.data?.data?.notepads))
      } else {
        throw response.data
      }
    } catch (error) {
      let message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      dispatch(myContentError({ action: 'get_my_content', message: message }))
    }
  }

  const updateMyContent = async (value) => {
    try {
      if (value !== myContent?.content[0]?.text) {
        const response = await api.patch(`/notepad`, { text: value })

        if (response.status === 200) {
          const message = response.data?.message
          myContent.content[0].text = value
          dispatch(updatedMyContent(message))
        } else {
          throw response.data
        }
      }
    } catch (error) {
      const message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      dispatch(
        myContentError({ action: 'update_my_content', message: message })
      )
    }
  }

  useEffect(() => {
    if (myContent.status?.get_my_content?.success) return
    getMyContent()
  }, [])

  useEffect(() => {
    if (myContentBoxRef?.current && myContent?.content?.length > 0) {
      myContentBoxRef.current.value = myContent.content[0].text
    }
  }, [myContent?.content])

  return (
    <>
      <Icon text={t('buttons.myContent')}>
        <MyContentIcon />
      </Icon>
      <div
        style={{
          marginTop: 15,
          marginBottom: 15,
        }}
      >
        <div className={classes.fieldContent}>
          <Textfield
            inputRef={myContentBoxRef}
            id={`field-text`}
            key={`field-text}`}
            type="text"
            color="primary"
            variant="outlined"
            name="message"
            multiline={true}
            rows={10}
            shrink={true}
            fullWidth={true}
            onBlur={(e) => updateMyContent(e.target.value)}
          />
        </div>
      </div>
    </>
  )
}

export default memo(MyContentComponent)
